export enum OptionTypeEnum {
	CALL = 'call',
	PUT = 'put',
}
